import React from "react";
import { useLocation, useParams, Outlet, useOutletContext } from "react-router-dom";
import NavTabs from "~components/NavTabs";
import ClientHeader from "~components/ClientInfo/ClientHeader";
import { useGetClientData } from "./hooks/use-get-client-data";
import useFooterDefaultOptions from "~components/Footer/hooks/useFooterDefaultOptions";

const PricesTableTabNavigation = () => {
  const path = useLocation().pathname;
  const { id } = useParams();
  const outletContext = useOutletContext();

  const { data: clientData, isLoading } = useGetClientData(id, !!id);

  useFooterDefaultOptions();

  const isNegotiationPath = path.includes("/nova-negociacao") || path.includes("/editar-negociacao");

  const getNavigationTabs = () => {
    if (id) {
      const clientePath = "/tabela-preco/" + id;
      const solicitacoesPath = clientePath + "/solicitacoes-preco";
      return [
        {
          name: "PREÇO DO CLIENTE",
          link: clientePath,
          className: path === clientePath ? "active" : "",
        },
        {
          name: "HISTÓRICO DE SOLICITAÇÕES DE PREÇO",
          link: solicitacoesPath,
          className: path.includes(solicitacoesPath) ? "active" : "",
        },
      ];
    }

    return [
      {
        name: "Negociações Vigentes",
        link: "/tabela-preco",
        className:
          path === "/tabela-preco" || path === "/tabela-preco/" || path.includes("/tabela-preco/proximas-do-vencimento")
            ? "active"
            : "",
      },
      
      {
        name: "Tabela de Regras",
        link: "/tabela-preco/preco-regra",
        className: path.includes("/tabela-preco/preco-regra") ? "active" : "",
      },
      {
        name: "Minhas Solicitações",
        link: "/tabela-preco/minhas-solicitacoes",
        className: path.includes("/tabela-preco/minhas-solicitacoes") ? "active" : "",
      },
    ];
  };

  return (
    <div className="prices-table-container">
      {id && clientData && !isLoading && <ClientHeader dados={clientData} />}

      {!isNegotiationPath && <NavTabs navs={getNavigationTabs()} />}

      <div className="tab-content">
        <Outlet context={outletContext} />
      </div>
    </div>
  );
};

export default PricesTableTabNavigation;
